// src/pages/dashboard/talent/CastingFeedback.js

import React, {
  useState
} from 'react';

import Swal from 'sweetalert2';

import {
  Star
} from 'lucide-react';

import {createDirectorFeedbackApi} from '../../../services/api';

import './CastingFeedback.css';

// const CastingFeedback = () => {
  const CastingFeedback = ({directorId,roleId,applicationId,roleName }) => {
    console.log("FEEDBACK DATA =>", {

  directorId,

  roleId,

  applicationId

});
  // =====================================
  // STATES
  // =====================================

  const [
    formData,
    setFormData
  ] = useState({

    rating: 0,

    review: ''

  });

  const [
    loading,
    setLoading
  ] = useState(false);

  // =====================================
  // STARS
  // =====================================

  const renderStars =
  (value) => {

    return (

      <div className="bma-feedback-stars">

        {
          [1,2,3,4,5].map((star) => (

            <Star
              key={star}
              size={32}
              className={
                star <= value
                ? 'bma-star active'
                : 'bma-star'
              }
              onClick={() =>
                setFormData({

                  ...formData,

                  rating: star

                })
              }
            />

          ))
        }

      </div>

    );
  };

  const handleSubmit =
  async (e) => {

    e.preventDefault();

    if (!formData.rating) {

      return Swal.fire({

        icon: 'warning',

        title: 'Please give rating'

      });

    }

    try {

      setLoading(true);

      await createDirectorFeedbackApi({
          directorId,roleId,applicationId,roleName,

        rating:
        formData.rating,

        review:
        formData.review

      });

      Swal.fire({

        icon: 'success',

        title:
        'Feedback Submitted',

        timer: 2000,

        showConfirmButton: false

      });

      // RESET

      setFormData({

        rating: 0,

        review: ''

      });

    } catch (err) {

      Swal.fire({

        icon: 'error',

        title:
        err.response?.data?.message
        || 'Submission Failed'

      });

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="bma-feedback-page">

      <div className="bma-feedback-card">

        {/* HEADER */}

        <div className="bma-feedback-header">

          <h2 className="bma-feedback-title">

            Share Your Review

          </h2>

          <p className="bma-feedback-subtitle">

            Share your audition experience and feedback

          </p>

        </div>

        {/* FORM */}

        <form onSubmit={handleSubmit}>


          {/* OVERALL RATING */}

          <div className="bma-feedback-group">

            <label>

               Rating

            </label>

            {
              renderStars(
                formData.rating
              )
            }

          </div>


          {/* REVIEW */}

          <div className="bma-feedback-group">

            <label>

              Your Feedback

            </label>

            <textarea
              rows="5"
              maxLength={100}
              placeholder="Write your feedback..."
              value={formData.review}
              onChange={(e) =>
                setFormData({

                  ...formData,

                  review:
                  e.target.value

                })
              }
              className="bma-feedback-textarea"
            />

            <div className="text-end text-light small mt-1">

              {formData.review.length}/100

            </div>
          </div>
          {/* BUTTON */}
          <button
            type="submit"
            className="bma-feedback-btn"
            disabled={loading}
          >
            {
              loading
              ? 'Submitting...'
              : 'Submit Feedback'
            }

          </button>

        </form>

      </div>

    </div>

  );

};

export default CastingFeedback;